var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 15,
  viewBox: "0 0 20 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.7125 2.70957L7.7125 14.7096C7.5125 14.8996 7.2625 14.9996 7.0025 14.9996C6.7425 14.9996 6.4925 14.8996 6.2925 14.7096L0.2925 8.70957C-0.0975 8.31957 -0.0975 7.68957 0.2925 7.29957C0.6825 6.90957 1.3125 6.90957 1.7025 7.29957L7.0025 12.5896L18.2925 1.28957C18.6825 0.89957 19.3125 0.89957 19.7025 1.28957C20.0925 1.67957 20.1025 2.31957 19.7125 2.70957Z",
  fill: "white"
})));
export { SvgSuccess as ReactComponent };
export default __webpack_public_path__ + "assets/icons/success.972349.svg";